import { Table } from '@shape-ds/components';
import { useCaseRelatedAlarms } from 'queries/cases/queries';
import { CaseForm } from 'queries/cases/types';
import { useFormContext } from 'react-hook-form';
import { useRelatedAlarmColumns } from '../../hooks/useRelatedAlarmColumns';
import { NoData } from '../NoData/NoData';
import './RelatedAlarms.scss';
import { useRelatedAlarmHook } from './useRelatedAlarmHook';

export const RelatedAlarmsForm = () => {
  const { watch } = useFormContext<CaseForm>();
  const { isFetching } = useCaseRelatedAlarms({ id: watch('id') });
  const alarms = watch('alarms');

  const { groupedData } = useRelatedAlarmHook();

  const { columns } = useRelatedAlarmColumns();
  const hasAlarms = alarms?.length > 0;

  return hasAlarms ? (
    <Table className="case-related-alarms-table" data={groupedData} columns={columns} style={{}} />
  ) : (
    <NoData i18nKey="case:no_data.related_alarms" icon={null} isLoading={isFetching} />
  );
};
